import { Navigate } from "react-router-dom";
import { LoadingCard } from "@/components/LoadingCard";
import { AuthGate } from "@/components/AuthGate";
import { useMyDataQuery } from "@/generated/graphql";
import { useTranslation } from "react-i18next";
import { useHomeRoute } from "@/hooks/use-home-route";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminOnly = ({ children }: AdminRouteProps) => {
  const { data, loading: dataLoading } = useMyDataQuery();
  const { t } = useTranslation();
  const { route: homeRoute } = useHomeRoute();

  if (dataLoading) {
    return <LoadingCard fullScreen message={t('common.checkingPermissions')} />;
  }

  const isAdmin = data?.myData?.is_admin === true;

  if (!isAdmin) {
    return <Navigate to={homeRoute} replace />;
  }

  return <>{children}</>;
};

const AdminRoute = ({ children }: AdminRouteProps) => {
  return (
    <AuthGate>
      <AdminOnly>{children}</AdminOnly>
    </AuthGate>
  );
};

export default AdminRoute;
